import { render, staticRenderFns } from "./icare_people_detail_group.vue?vue&type=template&id=3b0d2355&scoped=true&"
import script from "./icare_people_detail_group.vue?vue&type=script&lang=js&"
export * from "./icare_people_detail_group.vue?vue&type=script&lang=js&"
import style0 from "./icare_people_detail_group.vue?vue&type=style&index=0&id=3b0d2355&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d2355",
  null
  
)

export default component.exports